import { render } from "./ToggleFavorite.vue?vue&type=template&id=a668899e"
import script from "./ToggleFavorite.vue?vue&type=script&lang=js"
export * from "./ToggleFavorite.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__